export { demoProjectRoot } from "../platform/projectRoot";
export {
  resetDemoSession,
  getDemoSession,
  isDemoSessionActive,
  demoInvoke,
  buildPayload,
  demoAbs,
} from "./session";
export { buildDemoFixture, clearDemoFixtureCache } from "./fixture";

import { normalizePayload, type EditorPayload } from "../tauri/core";
import {
  buildPayload,
  resetDemoSession,
  type DemoDocumentFormat,
} from "./session";

export type { DemoDocumentFormat };

/** Reset the in-memory demo project and return a normalized editor payload. */
export async function openDemoProject(
  format: DemoDocumentFormat = "zwdoc",
): Promise<EditorPayload> {
  await resetDemoSession(format);
  return normalizePayload(buildPayload());
}
